import _ from 'lodash';
import moment from 'moment';
import 'moment-duration-format/lib/moment-duration-format.js';

export default formatActivity;

/**
 * @name formatActivity
 * @description Formats an appointment
 * @param {object} type The type of object activity to format
 * @param {object} activity The activity to format
 * @return {object} formatted Returns the formatted activity
 */
function formatActivity(type, activity) {
  if (type === 'project') {
    return formatProjectActivity(activity);
  }
  return formatAppointmentActivity(activity);
}

/**
 * @name formatProjectActivity
 * @description Function to format project activity
 * @param {array} activity The activity to format
 * @return {string} Returns the formatted activity
 */
function formatProjectActivity(activity) {
  let formattedActivities = [];
  _.forEach(activity, function(eachActivity) {
    let activityObject = {
      type: 'activity',
      object: 'project',
      projectId: eachActivity.object_id,
      created: eachActivity.created,
      collector: eachActivity.collector,
      id: eachActivity.id,
      description: []
    };

    // Coverup field updates
    if (!_.isUndefined(eachActivity.changes.coverup)) {
      let changeValues = [];
      _.forEach(eachActivity.changes.coverup, function(value) {
        if (value === true) {
          changeValues.push('Yes');
        } else {
          changeValues.push('No');
        }
      });
      let formattedChange = {};
      if (eachActivity.changes.coverup[0] === null) {
        formattedChange.message = 'set the coverup status';
        formattedChange.oldValue = null;
        formattedChange.newValue = eachActivity.changes.style[1];
      } else {
        formattedChange.message = 'changed the coverup status';
        formattedChange.oldValue = changeValues[0];
        formattedChange.newValue = changeValues[1];
      }
      activityObject.description.push(formattedChange);
    }

    // Full color field updates
    if (!_.isUndefined(eachActivity.changes.full_color)) {
      let changeValues = [];
      _.forEach(eachActivity.changes.full_color, function(colorValue) {
        if (colorValue === true) {
          changeValues.push('Full color');
        } else {
          changeValues.push('Black and gray');
        }
      });
      let formattedChange = {};
      if (eachActivity.changes.full_color[0] === null) {
        formattedChange.message = 'set the color type';
        formattedChange.oldValue = null;
        formattedChange.newValue = eachActivity.changes.style[1];
      } else {
        formattedChange.message = 'changed the color type';
        formattedChange.oldValue = changeValues[0];
        formattedChange.newValue = changeValues[1];
      }
      activityObject.description.push(formattedChange);
    }

    // Area and location field updates
    if (!_.isUndefined(eachActivity.changes.location)) {
      let formattedChange = {};
      if (eachActivity.changes.location[0] === null) {
        formattedChange.message = 'set the tattoo location';
        formattedChange.oldValue = null;
        formattedChange.newValue = eachActivity.changes.location[1].area +
          ': ' + eachActivity.changes.location[1].location;
      } else if (eachActivity.changes.location[1] === null) {
        formattedChange.message = 'removed the tattoo location';
        formattedChange.oldValue = eachActivity.changes.location[0].area +
          ': ' + eachActivity.changes.location[0].location;
        formattedChange.newValue = null;
      } else {
        formattedChange.message = 'changed the tattoo location';
        formattedChange.oldValue = eachActivity.changes.location[0].area +
          ': ' + eachActivity.changes.location[0].location;
        formattedChange.newValue = eachActivity.changes.location[1].area +
          ': ' + eachActivity.changes.location[1].location;
      }
      activityObject.description.push(formattedChange);
    }

    // Name field updates
    if (!_.isUndefined(eachActivity.changes.name)) {
      let formattedChange = {};
      if (eachActivity.changes.name[0] === null) {
        formattedChange.message = 'set the project name';
        formattedChange.oldValue = null;
        formattedChange.newValue = eachActivity.changes.name[1];
      } else {
        formattedChange.message = 'changed the project name';
        formattedChange.oldValue = eachActivity.changes.name[0];
        formattedChange.newValue = eachActivity.changes.name[1];
      }
      activityObject.description.push(formattedChange);
    }

    // Size field updates
    if (!_.isUndefined(eachActivity.changes.size)) {
      let formattedChange = {};
      if (eachActivity.changes.size[0] === null) {
        formattedChange.message = 'set the tattoo size';
        formattedChange.oldValue = null;
        formattedChange.newValue = eachActivity.changes.size[1];
      } else if (eachActivity.changes.size[1] === null) {
        formattedChange.message = 'removed the tattoo size';
        formattedChange.oldValue = eachActivity.changes.size[0];
        formattedChange.newValue = null;
      } else {
        formattedChange.message = 'changed the tattoo size';
        formattedChange.oldValue = eachActivity.changes.size[0];
        formattedChange.newValue = eachActivity.changes.size[1];
      }
      activityObject.description.push(formattedChange);
    }

    // width field updates
    if (!_.isUndefined(eachActivity.changes.width)) {
      let formattedChange = {};
      if (eachActivity.changes.width[0] === null) {
        formattedChange.message = 'set the project width';
        formattedChange.oldValue = null;
        formattedChange.newValue = eachActivity.changes.width[1] + '"';
      } else if (eachActivity.changes.width[1] === null) {
        formattedChange.message = 'removed the tattoo width';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      } else {
        formattedChange.message = 'changed the project width';
        formattedChange.oldValue = eachActivity.changes.width[0] + '"';
        formattedChange.newValue = eachActivity.changes.width[1] + '"';
      }
      activityObject.description.push(formattedChange);
    }

    // height field updates
    if (!_.isUndefined(eachActivity.changes.height)) {
      let formattedChange = {};
      if (eachActivity.changes.height[0] === null) {
        formattedChange.message = 'set the project height';
        formattedChange.oldValue = null;
        formattedChange.newValue = eachActivity.changes.height[1] + '"';
      } else if (eachActivity.changes.height[1] === null) {
        formattedChange.message = 'removed the tattoo height';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      } else {
        formattedChange.message = 'changed the project height';
        formattedChange.oldValue = eachActivity.changes.height[0] + '"';
        formattedChange.newValue = eachActivity.changes.height[1] + '"';
      }
      activityObject.description.push(formattedChange);
    }

    // Style field updates
    if (!_.isUndefined(eachActivity.changes.style)) {
      let formattedChange = {};
      if (eachActivity.changes.style[0] === null) {
        formattedChange.message = 'set the project style';
        formattedChange.oldValue = null;
        formattedChange.newValue = eachActivity.changes.style[1];
      } else if (eachActivity.changes.style[1] === null) {
        formattedChange.message = 'removed the tattoo style';
        formattedChange.oldValue = eachActivity.changes.style[0];
        formattedChange.newValue = null;
      } else {
        formattedChange.message = 'changed the project style';
        formattedChange.oldValue = eachActivity.changes.style[0];
        formattedChange.newValue = eachActivity.changes.style[1];
      }
      activityObject.description.push(formattedChange);
    }

    // Tattoo concept field updates
    if (!_.isUndefined(eachActivity.changes.tattoo_concept)) {
      let formattedChange = {};
      if (eachActivity.changes.tattoo_concept[0] === null) {
        formattedChange.message = 'added a concept for this project';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      } else {
        formattedChange.message = 'updated the concept of this project';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }
      activityObject.description.push(formattedChange);
    }

    // Reference images updates
    if (!_.isUndefined(eachActivity.changes.reference_images)) {
      let formattedChange = {};

      // New images
      if (eachActivity.changes.reference_images[1].length > 0) {
        let newImages = _.filter(eachActivity.changes.reference_images[1],
        function(image) {
          return image.indexOf('tmpimages') > -1;
        });

        if (newImages.length === 1) {
          formattedChange.message = 'added ' + newImages.length + ' reference image';
        } else if (newImages.length > 1) {
          formattedChange.message = 'added ' + newImages.length + ' reference images';
        }
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Deleted images
      // if (eachActivity.changes.reference_images[0].length > 0 &&
      // eachActivity.changes.reference_images[1].length >= 0) {
      //   let unchangedImages = _.intersection(eachActivity.changes.reference_images[0], eachActivity.changes.reference_images[1]);
      //   let deletedImages =
      //   _.difference(eachActivity.changes.reference_images[0],
      //   eachActivity.changes.reference_images[1]);
      //
      //   if (deletedImages.length > 0) {
      //     formattedChange.message += ' and removed ' +
      //     deletedImages.length + ' images';
      //   }
      // }
      activityObject.description.push(formattedChange);
    }

    // Placement images updates
    if (!_.isUndefined(eachActivity.changes.coverup_images)) {
      let formattedChange = {};

      // New images
      if (eachActivity.changes.coverup_images[1].length > 0) {
        let newImages = _.filter(eachActivity.changes.coverup_images[1],
        function(image) {
          return image.indexOf('tmpimages') > -1;
        });

        if (newImages.length === 1) {
          formattedChange.message = 'added ' + newImages.length + ' placement photo';
        } else if (newImages.length > 1) {
          formattedChange.message = 'added ' + newImages.length + ' placement photos';
        }
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }
      activityObject.description.push(formattedChange);
    }

    // Completed images updates
    if (!_.isUndefined(eachActivity.changes.completed_images)) {
      let formattedChange = {};

      // New images
      if (eachActivity.changes.completed_images[1].length > 0) {
        let newImages = _.filter(eachActivity.changes.completed_images[1],
        function(image) {
          return image.indexOf('tmpimages') > -1;
        });

        if (newImages.length === 1) {
          formattedChange.message = 'added ' + newImages.length + ' completed photo';
        } else if (newImages.length > 1) {
          formattedChange.message = 'added ' + newImages.length + ' completed photos';
        }
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }
      activityObject.description.push(formattedChange);
    }
    formattedActivities.push(activityObject);
  });
  return formattedActivities;
}

/**
 * @name formatAppointmentActivity
 * @description Function to format appointment activity
 * @param {array} activity The activity to format
 * @return {string} Returns the placeholder message
 */
function formatAppointmentActivity(activity) {
  let formattedActivities = [];
  _.forEach(activity, function(eachActivity) {
    let activityObject = {
      type: 'activity',
      object: 'appointment',
      appointmentId: eachActivity.object_id,
      created: eachActivity.created,
      collector: eachActivity.collector,
      id: eachActivity.id,
      description: []
    };

    // Status field updates
    if (!_.isUndefined(eachActivity.changes.status)) {
      let formattedChange = {};

      // Request declined
      if (eachActivity.changes.status[1] === 'Request declined') {
        formattedChange.message = 'declined this appointment request';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Expired
      if (eachActivity.changes.status[1] === 'Expired') {
        formattedChange.message =
        'allowed this appointment request to expire';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Unconfirmed = appointment sent to collector to confirm
      if (eachActivity.changes.status[1] === 'Unconfirmed') {
        formattedChange.message =
          'sent an appointment for confirmation';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Unconfirmed and estimate min/max old values are NOT null = Project
      // set to reschedule later
      if (eachActivity.changes.status[1] === 'Requested' &&
      eachActivity.changes.status[0] === 'Confirmed') {
        formattedChange.message =
          'set this appointment to be rescheduled later';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;

        // Requested
      } else if (eachActivity.changes.status[1] === 'Requested') {
        formattedChange.message = 'requested an appointment for this project';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Confirmed
      if (eachActivity.changes.status[1] === 'Confirmed') {
        formattedChange.message = 'confirmed this appointment request';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Collector declined
      if (eachActivity.changes.status[1] === 'Declined') {
        formattedChange.message = 'declined this appointment';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Completed
      if (eachActivity.changes.status[1] === 'Completed') {
        formattedChange.message = 'completed this appointment';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Collector and artist cancelled
      if (eachActivity.changes.status[1] === 'Collector cancelled' ||
      eachActivity.changes.status[1] === 'Artist cancelled') {
        formattedChange.message = 'cancelled this appointment';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Collector archived
      if (eachActivity.changes.status[1] === 'Archived') {
        formattedChange.message = 'archived this appointment';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      activityObject.description.push(formattedChange);
    }

    // Price field updates
    if (!_.isUndefined(eachActivity.changes.price)) {
      let formattedChange = {};
      if (eachActivity.changes.price[0] === null) {
        formattedChange.message = 'set the price';
        formattedChange.oldValue = null;
        formattedChange.newValue = '$' + eachActivity.changes.price[1];
      } else {
        formattedChange.message = 'changed the price';
        formattedChange.oldValue = '$' + eachActivity.changes.price[0];
        formattedChange.newValue = '$' + eachActivity.changes.price[1];
      }
      activityObject.description.push(formattedChange);
    }

    // Estimate min and max field updates
    if (!_.isUndefined(eachActivity.changes.estimate_min) &&
    _.isUndefined(eachActivity.changes.estimate_max)) {
      let formattedChange = {};
      if (eachActivity.changes.estimate_min[0] === null) {
        formattedChange.message = 'set the estimate minimum';
        formattedChange.oldValue = null;
        formattedChange.newValue = '$' + eachActivity.changes.estimate_min[1];
      } else {
        formattedChange.message = 'changed the estimate minimum';
        formattedChange.oldValue = '$' + eachActivity.changes.estimate_min[0];
        formattedChange.newValue = '$' + eachActivity.changes.estimate_min[1];
      }
      activityObject.description.push(formattedChange);
    }
    if (!_.isUndefined(eachActivity.changes.estimate_max) &&
    _.isUndefined(eachActivity.changes.estimate_min)) {
      let formattedChange = {};
      if (eachActivity.changes.estimate_max[0] === null) {
        formattedChange.message = 'set the estimate maximum';
        formattedChange.oldValue = null;
        formattedChange.newValue = '$' + eachActivity.changes.estimate_max[1];
      } else {
        formattedChange.message = 'changed the estimate maximum';
        formattedChange.oldValue = '$' + eachActivity.changes.estimate_max[0];
        formattedChange.newValue = '$' + eachActivity.changes.estimate_max[1];
      }
      activityObject.description.push(formattedChange);
    }
    if (!_.isUndefined(eachActivity.changes.estimate_min) &&
    !_.isUndefined(eachActivity.changes.estimate_max)) {
      let formattedChange = {};
      if (eachActivity.changes.estimate_min[0] === null) {
        formattedChange.message = 'set the estimate range';
        formattedChange.oldValue = null;
        formattedChange.newValue = '$' + eachActivity.changes.estimate_min[1];
      } else {
        formattedChange.message = 'changed the estimate range';
        formattedChange.oldValue = '$' + eachActivity.changes.estimate_min[0];
        formattedChange.newValue = '$' + eachActivity.changes.estimate_min[1];
      }
      if (eachActivity.changes.estimate_max[0] === null) {
        formattedChange.oldValue = null;
        formattedChange.newValue +=
        ' to $' + eachActivity.changes.estimate_max[1];
      } else {
        formattedChange.oldValue +=
        ' to $' + eachActivity.changes.estimate_max[0];
        formattedChange.newValue +=
        ' to $' + eachActivity.changes.estimate_max[1];
      }
      activityObject.description.push(formattedChange);
    }

    // Deposit amount
    if (!_.isUndefined(eachActivity.changes.deposit_amount)) {
      let formattedChange = {};
      if (eachActivity.changes.deposit_amount[0] === null &&
      eachActivity.changes.deposit_amount[1] === 0) {
        formattedChange.message = 'set no deposit required';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      } else if (eachActivity.changes.deposit_amount[1] === 0 ||
      eachActivity.changes.deposit_amount[1] === null) {
        formattedChange.message = 'removed a required deposit amount';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      } else if ((eachActivity.changes.deposit_amount[0] === null ||
      eachActivity.changes.deposit_amount[0] === 0) &&
      eachActivity.changes.deposit_amount[1] !== 0) {
        formattedChange.message = 'set the deposit amount';
        formattedChange.oldValue = null;
        formattedChange.newValue =
          '$' + eachActivity.changes.deposit_amount[1];
      } else {
        formattedChange.message = 'changed the deposit amount';
        formattedChange.oldValue =
          '$' + eachActivity.changes.deposit_amount[0];
        formattedChange.newValue =
          '$' + eachActivity.changes.deposit_amount[1];
      }
      activityObject.description.push(formattedChange);
    }

    // Previously paid
    if (!_.isUndefined(eachActivity.changes.previously_paid)) {
      let changeValues = [];
      _.forEach(eachActivity.changes.previously_paid, function(value) {
        if (value === true) {
          changeValues.push('Yes');
        } else {
          changeValues.push('No');
        }
      });
      let formattedChange = {};
      if (eachActivity.changes.previously_paid[0] === null) {
        formattedChange.message = 'set the previously paid status';
        formattedChange.oldValue = null;
        formattedChange.newValue = changeValues[1];
      } else {
        formattedChange.message = 'changed the previously paid status';
        formattedChange.oldValue = changeValues[0];
        formattedChange.newValue = changeValues[1];
      }
      activityObject.description.push(formattedChange);
    }

    // Appointment datetime
    if (!_.isUndefined(eachActivity.changes.appointment_datetime)) {
      let formattedChange = {};
      if (eachActivity.changes.appointment_datetime[0] === null) {
        formattedChange.message = 'set the appointment date and time';
        formattedChange.oldValue = null;
        formattedChange.newValue =
          moment(eachActivity.changes.appointment_datetime[1])
          .format('MMMM Do, YYYY') + ' at ' +
          moment(eachActivity.changes.appointment_datetime[1])
          .format('h:mm a');
      } else {
        formattedChange.message = 'changed the appointment date and time';
        formattedChange.oldValue =
          moment(eachActivity.changes.appointment_datetime[0])
          .format('MMMM Do, YYYY') + ' at ' +
          moment(eachActivity.changes.appointment_datetime[0])
          .format('h:mm a');
        formattedChange.newValue =
          moment(eachActivity.changes.appointment_datetime[1])
          .format('MMMM Do, YYYY') + ' at ' +
          moment(eachActivity.changes.appointment_datetime[1])
          .format('h:mm a');
      }
      activityObject.description.push(formattedChange);
    }

    // Artist updates
    if (!_.isUndefined(eachActivity.changes.artist)) {
      let formattedChange = {};
      if (eachActivity.changes.artist[0] === null) {
        formattedChange.message = 'set the artist';
        formattedChange.oldValue = null;
        formattedChange.newValue = eachActivity.changes.artist[1].first_name +
        ' ' + eachActivity.changes.artist[1].last_name;
      } else {
        formattedChange.message = 'changed the artist';
        formattedChange.oldValue = eachActivity.changes.artist[0].first_name +
        ' ' + eachActivity.changes.artist[0].last_name;
        formattedChange.newValue = eachActivity.changes.artist[1].first_name +
        ' ' + eachActivity.changes.artist[1].last_name;
      }
      activityObject.description.push(formattedChange);
    }

    // Managed by updates
    if (!_.isUndefined(eachActivity.changes.managed_by)) {
      let formattedChange = {};
      if (eachActivity.changes.managed_by[0] === null) {
        formattedChange.message =
          'set the operator managing this appointment';
        formattedChange.oldValue = null;
        formattedChange.newValue =
          eachActivity.changes.managed_by[1].first_name +
        ' ' + eachActivity.changes.managed_by[1].last_name;
      } else if (eachActivity.changes.managed_by[1] === null) {
        formattedChange.message =
          'removed this operator as appointment manager:';
        formattedChange.oldValue =
        eachActivity.changes.managed_by[0].first_name +
        ' ' + eachActivity.changes.managed_by[0].last_name;
        formattedChange.newValue = null;
      } else {
        formattedChange.message =
          'changed the operator managing this appointment';
        formattedChange.oldValue =
          eachActivity.changes.managed_by[0].first_name +
        ' ' + eachActivity.changes.managed_by[0].last_name;
        formattedChange.newValue =
          eachActivity.changes.managed_by[1].first_name +
        ' ' + eachActivity.changes.managed_by[1].last_name;
      }
      activityObject.description.push(formattedChange);
    }

    // Length updates
    if (!_.isUndefined(eachActivity.changes.length)) {
      let formattedChange = {};
      if (eachActivity.changes.length[0] === null) {
        formattedChange.message = 'set the appointment length';
        formattedChange.oldValue = null;
        formattedChange.newValue =
          moment.duration(eachActivity.changes.length[1])
          .format('h [hours] m [minutes]')
          .replace(/\s0\s\w+/g, '');
      } else {
        formattedChange.message = 'changed the appointment length';
        formattedChange.oldValue =
          moment.duration(eachActivity.changes.length[0])
          .format('h [hours] m [minutes]')
          .replace(/\s0\s\w+/g, '');
        formattedChange.newValue =
          moment.duration(eachActivity.changes.length[1])
          .format('h [hours] m [minutes]')
          .replace(/\s0\s\w+/g, '');
      }
      activityObject.description.push(formattedChange);
    }

    // Cancellation policy
    if (!_.isUndefined(eachActivity.changes.agreed_to_cancellation_policy)) {
      let formattedChange = {};
      formattedChange.oldValue = null;
      formattedChange.newValue = null;
      if (eachActivity.changes.agreed_to_cancellation_policy[1] === true) {
        formattedChange.message = 'agreed to the cancellation policy';
      }
      activityObject.description.push(formattedChange);
    }

    // Push the formatted object to the array if there's a collector available
    if (activityObject.collector !== null) {
      formattedActivities.push(activityObject);
    }
  });
  return formattedActivities;
}



// WEBPACK FOOTER //
// ./utils/format-activity.js